module.exports = __webpack_public_path__ + "img/1x.c2e3d8b.jpg";